import { BBDTag, Texto } from '@gravitate-js/excalibrr'
import { Button, Col, Form, Row, Tooltip } from 'antd'
import { FormInput } from '../../../../../_SiteWide/Form/FormInput'
import { Switch } from 'antd/lib'
export const StoreNumberTankIdStatusRow = ({ tank, editing }) => {
  const isActive = !!tank.active
  return (
    <Row>
      {editing ? (
        <Col className='pt-2' span={12}>
          <FormInput
            name='description'
            message='Tank Description is required'
            placeholder='Description'
            width='90%'
            editable={editing}
            initialValue={tank.description}
          />
        </Col>
      ) : (
        <Col className='pt-2' span={12}>
          <Tooltip title={tank.description}>
            <Button style={{ maxWidth: '100%' }} appearance='ghost' className='ghost-gravi-button'>
              <Texto className={'text-truncate'}> {tank.description}</Texto>
            </Button>
          </Tooltip>
        </Col>
      )}

      {editing ? (
        <Col className='pt-2' span={12}>
          <div className='flex justify-end'>
            <Texto appearance='medium' className='pr-3'>
              Active
            </Texto>
            <Form.Item name={'active'} noStyle initialValue={isActive}>
              <Switch checkedChildren={'Active'} unCheckedChildren={'Inactive'} />
            </Form.Item>
          </div>
        </Col>
      ) : (
        <Col align='right' span={6}>
          <BBDTag theme2={isActive} error={!isActive}>
            {tank.active ? 'Active' : 'Inactive'}
          </BBDTag>
        </Col>
      )}
    </Row>
  )
}
